import { createApp } from "vue";
import App from "./App.vue";
import { GoogleMap, Marker, Polygon } from "vue3-google-map";

const app = createApp(App);
app.component("GoogleMap", GoogleMap);
app.component("GoogleMapMarker", Marker);
app.component("GoogleMapPolygon", Polygon);
app.mount("#app");
